// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
const Pricing = () => (
  <section id="pricing" style={{ background: "#FFFFFF", borderTop: "1px solid #E1E5F7" }}>
    <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "112px 24px", display: "flex", flexDirection: "column", gap: "44px" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "14px", alignItems: "center", textAlign: "center" }}>
        <span style={{ fontWeight: "700", color: "#1E8F80", fontSize: "16px" }}>
          الاشتراكات
        </span>
        <h2 style={{ margin: "0", fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "clamp(34px, 4vw, 52px)", lineHeight: "1.2" }}>
          ابدأ مجّانًا… وواصل مع العائلة
        </h2>
        <div role="group" aria-label="مدّة الاشتراك" style={{ display: "inline-flex", gap: "4px", padding: "4px", borderRadius: "999px", background: "#F3F5FF", border: "1px solid #E1E5F7" }}>
          <button type="button" data-bill="tri" style={{ minHeight: "44px", padding: "0 20px", borderRadius: "999px", border: "0", cursor: "pointer", fontWeight: "700", background: "#141C63", color: "#FFFFFF" }} aria-pressed="true">
            ثلاثي
          </button>
          <button type="button" data-bill="sem" style={{ minHeight: "44px", padding: "0 20px", borderRadius: "999px", border: "0", cursor: "pointer", fontWeight: "700", background: "transparent", color: "#121A4A" }} aria-pressed="false">
            سداسي · [-X٪]
          </button>
          <button type="button" data-bill="year" style={{ minHeight: "44px", padding: "0 20px", borderRadius: "999px", border: "0", cursor: "pointer", fontWeight: "700", background: "transparent", color: "#121A4A" }} aria-pressed="false">
            سنوي · [-X٪]
          </button>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(320px, 100%), 1fr))", gap: "22px" }}>
        <article style={{ border: "1px solid #E1E5F7", borderRadius: "28px", padding: "34px", display: "flex", flexDirection: "column", gap: "20px", background: "#F3F5FF" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <h3 style={{ margin: "0", fontSize: "24px" }}>
              اكتشاف
            </h3>
            <span style={{ color: "#4B5480" }}>
              للتجربة مع طفلك
            </span>
          </div>
          <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "46px" }}>
            0 د.ت
          </span>
          <ul style={{ margin: "0", padding: "0 18px 0 0", display: "flex", flexDirection: "column", gap: "10px", fontSize: "16px", flex: "1" }}>
            <li>
              العرض التجريبي
            </li>
            <li>
              {" أنشطة مجّانيّة"}
            </li>
            <li>
              ملفّ طفل واحد
            </li>
            <li>
              الدرس الأول من كل مادة مجاني
            </li>
          </ul>
          <a href="https://play.google.com/store/apps/details?id=com.DMNovaComany.Khotoua&pcampaignid=web_share" target="_blank" rel="noopener" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "52px", borderRadius: "16px", border: "2px solid #141C63", color: "#141C63", fontWeight: "800", textDecoration: "none" }}>
            حمل التطبيق و جرّب الآن
          </a>
        </article>
        <article style={{ borderRadius: "28px", padding: "34px", display: "flex", flexDirection: "column", gap: "20px", background: "#141C63", color: "#FFFFFF", position: "relative" }}>
          <span style={{ position: "absolute", top: "-14px", right: "34px", padding: "6px 14px", borderRadius: "999px", background: "#FFC93C", color: "#0B1240", fontWeight: "800", fontSize: "13px" }}>
            الأكثر اختيارًا
          </span>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <h3 style={{ margin: "0", fontSize: "24px" }}>
              العائلة
            </h3>
            <span style={{ color: "#C9CEF5" }}>
              كلّ عوالم خطوة لكلّ الإخوة
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "baseline", gap: "8px" }}>
            <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "46px" }} id="kh-price">
              [السعر الثلاثي] د.ت
            </span>
            <span style={{ color: "#C9CEF5" }} id="kh-period">
              / الثلاثي
            </span>
          </div>
          <ul style={{ margin: "0", padding: "0 18px 0 0", display: "flex", flexDirection: "column", gap: "10px", fontSize: "16px", flex: "1" }}>
            <li>
              كلّ المحتويات التعليميّة الستّة
            </li>
            <li>
              الواقع المعزّز والموسوعة ثلاثيّة الأبعاد
            </li>
            <li>
              فضاء الولي والتقارير التطويريّة
            </li>
            <li>
              حتّى [عدد] ملفّات أطفال
            </li>
          </ul>
          <a href="https://play.google.com/store/apps/details?id=com.DMNovaComany.Khotoua&pcampaignid=web_share" target="_blank" rel="noopener" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "52px", borderRadius: "16px", background: "#46D3BE", color: "#0B1240", fontWeight: "800", textDecoration: "none" }}>
            اشترك الآن
          </a>
        </article>
        <article style={{ border: "1px solid #E1E5F7", borderRadius: "28px", padding: "34px", display: "flex", flexDirection: "column", gap: "20px", background: "#F3F5FF" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <h3 style={{ margin: "0", fontSize: "24px" }}>
              المدارس والمؤسّسات
            </h3>
            <span style={{ color: "#4B5480" }}>
              للأقسام والشبكات والوزارات
            </span>
          </div>
          <span style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontWeight: "800", fontSize: "40px" }}>
            حسب الطلب
          </span>
          <ul style={{ margin: "0", padding: "0 18px 0 0", display: "flex", flexDirection: "column", gap: "10px", fontSize: "16px", flex: "1" }}>
            <li>
              رخص حسب التلميذ أو المؤسّسة
            </li>
            <li>
              نظام إدارة المحتوى (CMS)
            </li>
            <li>
              تكوين ومرافقة المعلّمين
            </li>
          </ul>
          <a href="#contact" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "52px", borderRadius: "16px", background: "#141C63", color: "#FFFFFF", fontWeight: "800", textDecoration: "none" }}>
            تحدّث مع فريقنا
          </a>
        </article>
      </div>
    </div>
  </section>
);

export default Pricing;
